import { endpoints } from 'api/endpoints'
import { GetOneResponse } from 'interfaces/api.interfaces'
import { CfrLogLink, CfrLogsFileNames } from 'interfaces/api/cfrLogs.interfaces'
import { axios } from 'modules/axios'

const getAll = async (): GetOneResponse<CfrLogsFileNames> => {
  const { data: response } = await axios.request<CfrLogsFileNames>({
    method: 'GET',
    url: endpoints.cfrLogs.getAll(),
  })
  return response
}

const getLink = async (filename: string): GetOneResponse<CfrLogLink> => {
  const { data: response } = await axios.request<CfrLogLink>({
    method: 'GET',
    url: endpoints.cfrLogs.getLink(),
    params: { filename },
  })
  return response
}

const download = async (url: string): Promise<Blob> => {
  console.log(url)
  const { data } = await axios.request<File>({
    method: 'GET',
    url,
    responseType: 'blob',
  })
  return new Blob([data])
}

export const cfrLogsApi = {
  getAll,
  getLink,
  download,
}
